// MUCard/style.js — MUI v3/v4 uyumlu spacing
const styles = (theme) => {
  // spacing helper: v4 (function) ve v3 (unit) ile uyumlu
  const sp = (m) =>
    typeof theme.spacing === 'function'
      ? theme.spacing(m)
      : ((theme.spacing && theme.spacing.unit) ? theme.spacing.unit * m : 8 * m);

  return {
    media: {
      maxWidth: '100%',
      maxHeight: '100%',
      minHeight: '200px',
      backgroundSize: 'initial',
      paddingTop: 'inherit',
      [theme.breakpoints.down('sm')]: {
        minHeight: '160px',
        backgroundPosition: 'center',
        backgroundSize: 'contain',
      },
    },

    card: {
      maxWidth: 360,
      boxShadow: 'none',
      backgroundColor: '#FFF',
      textAlign: 'left',
      width: 444,
      height: '316px',
      marginBottom: '10px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: '100%',
        height: 'auto',
        marginBottom: 16,
        boxShadow: '0 8px 18px rgba(0,0,0,0.06)',
        borderRadius: 12,
      },
    },

    // CardActions root
    cardActions: {
      display: 'flex',
      justifyContent: 'center',
      padding: sp(1.5), // ← artık hatasız
    },

    // CardContent root
    cardContent: {
      padding: sp(2),   // ← artık hatasız
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: {
        padding: sp(2),
      },
    },

    // geri uyumluluk için eski isim
    actions: { display: 'flex' },

    avatar: {
      width: 120,
      height: 120,
      [theme.breakpoints.down('sm')]: { width: 64, height: 64 },
    },

    details: { display: 'flex', flexDirection: 'column' },

    content: { flex: '0 0 auto', paddingTop: '50px' },

    action: { alignSelf: 'flex-start', marginTop: 0 },

    cover: { width: 151, height: 151, margin: '20px' },

    header: { display: 'flex' },

    iconButton: { margin: '1px 1px 10px' },

    h2: {
      fontSize: '16px',
      fontFamily: 'Gilroy',
      fontWeight: 700,
      paddingTop: '5px',
      paddingLeft: '2px',
      textAlign: 'center',
      [theme.breakpoints.down('sm')]: { fontSize: '15px', paddingTop: 2 },
    },

    p: { display: 'flex', padding: '80px' },

    text: {
      fontSize: '14px',
      fontFamily: 'Gilroy-Light',
      [theme.breakpoints.down('sm')]: { fontSize: '13px', lineHeight: 1.4, textAlign: 'center' },
    },

    cardActionArea: {
      width: '100%',
      height: '350px',
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
      },
    },

    gutterBottom: { textAlign: 'center' },

    link: {
      color: 'black',
      textTransform: 'uppercase',
      '&:hover': { color: '#ED502E' },
    },
  };
};

export default styles;
